import { Card, CardContent, CardHeader, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function OccupancySummaryCard({ occupancyEventData }) {
    const { t } = useTranslation();

    const hoursUsed = occupancyEventData.points_data.reduce((acc, point) => acc + point.values.reduce((acc, value) => acc + value, 0), 0);

    const locationHours = occupancyEventData.points_data.reduce((acc, point) => acc + point.values.length, 0);

    const averageOccupancy = locationHours > 0 ? (hoursUsed / locationHours) * 100 : 0;

    const numLocations = new Set(occupancyEventData.points_data.map(pointData => pointData.metadata.location)).size;

    return (
        <Card sx={{ mx: { xs: 2, md: 3 }, my: 2 }}>
            <CardContent>
                <Typography padding={1} align="left" component="h2" variant="h6" color="primary" gutterBottom>
                    {t("Occupied")}
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                            <Typography variant="h4">
                                {averageOccupancy.toFixed(2)}%
                            </Typography>
                            <Typography variant="subtitle2">
                                {t("Average Occupancy")}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                            <Typography variant="h4">
                                {hoursUsed.toFixed(2)}
                            </Typography>
                            <Typography variant="subtitle2">
                                {t("Hours Used")}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                            <Typography variant="h4">
                                {numLocations}
                            </Typography>
                            <Typography variant="subtitle2">
                                {t("Locations")}
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}